<template>
    <div class="sound" @click="toggle">
        <div class="sound__state">
            <fade-scale-transition>
                <loader v-if="isLoading" :key="'loading'"></loader>
                <div v-if="!isLoading" :key="'loaded'" class="sound__button">
                    <fade-scale-transition>
                        <img class="sound__image" :key="'play'" src="/assets/icons/play.svg" :alt="`Play ${title} song`" v-if="!isPlaying">
                        <img class="sound__image" :key="'pause'" src="/assets/icons/pause.svg" :alt="`Pause ${title} song`" v-if="isPlaying">
                    </fade-scale-transition>
                </div>
            </fade-scale-transition>
        </div>
        <span class="sound__title">{{title}}</span>
    </div>
</template>
<script>
    import { Howl } from 'howler'
    import Loader from '@/components/Loader'
    export default {
        name: 'sound',
        props: {
            title: {
                type: String
            },
            url: {
                type: String,
                required: true
            },
        },
        data() {
            return {
                isLoaded: false,
                isLoading: false,
                isPlaying: false
            }
        },
        components: {
            Loader
        },
        methods: {
            instanciatePlayer() {
                if(!this.isLoaded) this.isLoading = true
                this.player = new Howl({
                    src: [this.url],
                    autoplay: true,
                    preload: true,
                    onload: () => {
                        this.isLoading = false
                        this.isLoaded = true
                        this.isPlaying = true
                    },
                    onplay: () => {
                        this.player.fade(0, 1, 500)
                    },
                    onend: () => {
                        this.isPlaying = false
                    }
                })
            },
            stop(title) {
                if(title == this.title) return
                if(this.player) {
                    this.isPlaying = false
                    this.player.fade(1, 0, 500)
                    setTimeout(() => {
                        this.player.pause()
                    }, 500)
                }
            },
            toggle() {
                if(this.isPlaying) this.stop()
                else {
                    this.$bus.$emit('sound:stop', this.title)
                    this.instanciatePlayer()
                }
            }
        },
        mounted() {
            this.$bus.$on('sound:stop', this.stop)
        }
    }
</script>
<style>
</style>